/* ========================================================================== *\
    IMPORTS
\* ========================================================================== */

import bind from 'lodash/bind';
import forEach from 'lodash/forEach';
import isNil from 'lodash/isNil';

/* == IMPORTS =============================================================== */



/* ========================================================================== *\
    PRIVATE VARIABLES
\* ========================================================================== */

const
    moduleName = 'share-widget',
    baseCssClass = `js-${moduleName}`,

    dataAttributes = {
        url: 'data-url',
        title: 'data-title'
    },
    propertyNames = {
        baseElement: Symbol('baseElement'),
        dialog: Symbol('dialog'),
        closeBtn: Symbol('closeBtn'),
        copyBtn: Symbol('copyBtn'),
        shareLink: Symbol('shareLink'),
        facebook: Symbol('facebook'),
        twitter: Symbol('twitter'),
        linkedin: Symbol('linkedin'),
        email: Symbol('email')
    },
    selectors = {
        base: `.${baseCssClass}`,
        shareBtns: `.${baseCssClass}-button`,
        dialog: `.${baseCssClass}-dialog`,
        closeBtn: `.${baseCssClass}-close-button`,
        shareLink: `.${baseCssClass}-share-link`,
        copyBtn: `.${baseCssClass}-copy-button`,
        facebook: `.${baseCssClass}-facebook`,
        twitter: `.${baseCssClass}-twitter`,
        linkedin: `.${baseCssClass}-linkedin`,
        email: `.${baseCssClass}-email`
    },
    states = {
        isOpen: 'is-open'
    };

/* == PRIVATE VARIABLES ===================================================== */



/* ========================================================================== *\
    EVENT HANDLING
\* ========================================================================== */

function bindEvents() {
    const
        dialog = this[propertyNames.dialog],
        shareBtns = this[propertyNames.shareBtns],
        closeBtn = this[propertyNames.closeBtn],
        copyBtn = this[propertyNames.copyBtn],
        shareLink = this[propertyNames.shareLink];
    if (
        dialog === null ||
        shareBtns === null ||
        closeBtn === null ||
        copyBtn === null ||
        shareLink === null )
    {
        return;
    }

    for (var i = 0; i < shareBtns.length; i++) {
        shareBtns[i].addEventListener('click', bind(onClickShareBtn, this));
    }

    closeBtn.addEventListener('click', bind(onClickCloseBtn, this));
    copyBtn.addEventListener('click', bind(onClickCopyBtn, this));
}

/* == EVENT HANDLING ======================================================== */



/* ========================================================================== *\
    PRIVATE METHODS
\* ========================================================================== */

function onClickCloseBtn() {
    this[propertyNames.dialog].classList.remove(states.isOpen);
}

function onClickCopyBtn() {
    const r = document.createRange();
    r.selectNode(document.querySelector(selectors.shareLink));
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(r);
    document.execCommand('copy');
    window.getSelection().removeAllRanges();
}

function onClickShareBtn(shareBtn) {
    const
        url = shareBtn.target.getAttribute(dataAttributes.url),
        title = shareBtn.target.getAttribute(dataAttributes.title),
        facebook = this[propertyNames.facebook],
        twitter = this[propertyNames.twitter],
        linkedin = this[propertyNames.linkedin],
        email = this[propertyNames.email];
  
    if (
        url === "" ||
        title === "" )
    {
        return;
    }        

    //If browser supports the native share API
    if (navigator.share) {
        navigator.share({
            title: title,
            url: url
        }).then(() => {
            console.log('Thanks for sharing!');
        }).catch(console.error);
    } else {
        if (this[propertyNames.dialog].classList.contains(states.isOpen) && this[propertyNames.shareLink].innerText.includes(url)) {
            this[propertyNames.dialog].classList.remove(states.isOpen);
        } else {
            this[propertyNames.dialog].classList.add(states.isOpen);
            this[propertyNames.shareLink].innerHTML = url;

            if (facebook !== null) {
                facebook.setAttribute("href", 'https://www.facebook.com/sharer.php?u=' + url);
            }

            if (twitter !== null) {
                twitter.setAttribute("href", 'https://twitter.com/intent/tweet?url=' + url + '&text=' + title);
            }

            if (linkedin !== null) {
                linkedin.setAttribute("href", 'https://www.linkedin.com/shareArticle?url=' + url + '&title=' + title);
            }

            if (linkedin !== null) {
                email.setAttribute("href", 'mailto:?subject=' + title + '&body=' + url);
            }
        }

    }
}

/* == PRIVATE METHODS ======================================================= */


/* ========================================================================== *\
    PUBLIC API
\* ========================================================================== */

class ShareWidget {

    /* ====================================================================== *\
        CONSTRUCTOR
    \* ====================================================================== */

    constructor(baseElement) {
        if (isNil(baseElement)) {
            throw 'Unable to create instance of ShareWidget, no base element has been provided';
        }

        this[propertyNames.baseElement] = baseElement;
        this[propertyNames.dialog] = baseElement.querySelector(selectors.dialog);
        this[propertyNames.shareBtns] = baseElement.querySelectorAll(selectors.shareBtns);
        this[propertyNames.closeBtn] = baseElement.querySelector(selectors.closeBtn);
        this[propertyNames.copyBtn] = baseElement.querySelector(selectors.copyBtn);
        this[propertyNames.shareLink] = baseElement.querySelector(selectors.shareLink);
        this[propertyNames.facebook] = baseElement.querySelector(selectors.facebook);
        this[propertyNames.twitter] = baseElement.querySelector(selectors.twitter);
        this[propertyNames.linkedin] = baseElement.querySelector(selectors.linkedin);
        this[propertyNames.email] = baseElement.querySelector(selectors.email);

        bindEvents.call(this);
    }

    /* == CONSTRUCTOR ======================================================= */
}

/* == PUBLIC API ============================================================ */



/* ========================================================================== *\
    INITIALIZATION
\* ========================================================================== */

function init(baseElements = document.querySelectorAll(selectors.base)) {
    if (
        baseElements === null ||
        baseElements.length === 0
    ) {
        return;
    }

    forEach(baseElements, baseElement => {
        new ShareWidget(baseElement);
    });
}

init();

/* == INITIALIZATION ======================================================== */